export default [
  {
    name: "Afrosoft",
    image: require("../assets/img/partners/afrosoft.png"),
    website: "https://www.afrosoft.co.zw",
  },
  {
    name: "BlissTech",
    image: require("../assets/img/partners/blisstech.png"),
    website: "https://www.blisstech.co.zw",
  },
  {
    name: "Distinct Media",
    image: require("../assets/img/partners/distictmedia.png"),
    website: "https://www.distinctmedia.co.zw",
  },
  {
    name: "NovaPay",
    image: require("../assets/img/clients/novapay.png"),
    website: "https://www.novapay.co.zw",
  },
  {
    name: "Reino Technologies",
    image: require("../assets/img/partners/reino.jpg"),
    website: "https://www.reino.co.zw/",
  },
  {
    name: "Reehive",
    image: require("../assets/img/partners/reehive.png"),
    website: "https://www.reehive.com/",
  },
];
